import React, { createContext, useContext, useState } from 'react';
import { storageData } from './Services';

const ServerDateContext = createContext(null);

export const useServerDate = () => useContext(ServerDateContext);

export const ServerDateProvider = ({ children }) => {
  const userData = JSON?.parse(storageData.getItem("userData"));
  const [serverDate, setServerDate] = useState(() => {
    if (!userData?.serverDate || userData?.serverDate == null) 
      return new Date();

    const [year, month, day] = userData?.serverDate.split('-');
    return new Date(year, month - 1, day);
  });

  if (!serverDate) return null; // or show loading

  return (
    <ServerDateContext.Provider value={serverDate}>
      {children}
    </ServerDateContext.Provider>
  );
};